<script setup lang="ts">
import VHeading from '@shared/typography/VHeading/VHeading.vue';
import ContactLink from './ContactLink.vue';

const props = defineProps<{
  omschrijving: string;
  telefoonnummer?: string | null;
  email?: string | null;
}>();
</script>

<template>
  <div class="mb-4 flex flex-wrap items-center gap-x-4 gap-y-2">
    <VHeading :level="3" appearance="m">{{ props.omschrijving }}</VHeading>
    <ContactLink v-if="props.telefoonnummer" type="phone" :value="props.telefoonnummer" />
    <ContactLink v-if="props.email" type="email" :value="props.email" />
  </div>
</template>
